import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ClienteService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getClientes(ordem = null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/clientes' + (ordem ? '/ordem/' + ordem : ''))
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}
	getCliente(cliente_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/clientes/' + cliente_id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getClientesByUsuario(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/clientes/usuario/' + usuario_id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}
	getVeiculosByUsuarioAndCliente(usuario_id, cliente_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/clientes/' + usuario_id + '/' + cliente_id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	criaCliente(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/clientes', {
				cliente_nome: data.cliente_nome,
				cliente_status: data.cliente_status
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	editaCliente(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/clientes/' + data.cliente_id, {
				cliente_nome: data.cliente_nome,
				cliente_status: data.cliente_status
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaCliente(id) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/clientes/' + id, {
				cliente_status: 'D'
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	atualizaStatus(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/clientes/' + data.cliente_id, {
				cliente_status: data.cliente_status
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}


	getSolicitanteClientesByUsuario(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/clientes/getSolicitantes/' + usuario_id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}


}
